/**
 * Marketer-view chrome tokens.
 *
 * Resolved from `App.tsx` ConfigProvider so the marketer view matches the
 * rest of the dashboard (slate-50 background, amber primary, Plus Jakarta
 * Sans, Antd card shadow). Per SYR-68 feedback: Adir's mockup is the source
 * of truth for CONTENT and structure, but visual aesthetics adhere to the
 * dashboard so the page doesn't look like a foreign island.
 *
 * Band colours (strong/watch/weak) live in `bandColours.ts` — those reflect
 * score meaning and stay aligned with the rest of the BE charts.
 */

export const THEME = Object.freeze({
  // Surfaces
  bgLayout: '#F8FAFC', // slate-50 — page background, matches Antd colorBgLayout
  bgCard: '#FFFFFF',
  bgTinted: '#FAFBFC',
  bgChip: '#F1F5F9',
  bgChipActive: '#FFFFFF',

  // Brand
  primary: '#F59E0B', // amber-500 — matches Antd colorPrimary
  primaryHover: '#D97706', // amber-600
  primaryDark: '#B45309', // amber-700
  primaryGradient: 'linear-gradient(135deg, #F59E0B 0%, #FBBF24 100%)',
  primarySoft: '#FEF3C7', // amber-100

  // Text
  textBase: '#0F172A', // slate-900 — matches Antd colorTextBase
  textSecondary: '#64748B', // slate-500
  textMuted: '#94A3B8', // slate-400

  // Borders
  border: '#E5E7EB',
  borderSubtle: '#F3F4F6',

  // Card shadow (mirrors Antd theme.components.Card.boxShadow)
  cardShadow:
    '0 4px 6px -1px rgba(0, 0, 0, 0.10), 0 2px 4px -1px rgba(0, 0, 0, 0.06)',

  // Translucent-on-page background for sticky bars (TopBar, sub-nav)
  stickyBg: 'rgba(248, 250, 252, 0.92)',

  // Font stack — MUST match `BrandEquityVisualizationWrapper.tsx` line 159
  // (system font, not Plus Jakarta Sans). User requirement: consistency with
  // the v3 orbital visualization. Applied at the page-level Content wrapper
  // and cascades to every child via CSS inheritance.
  fontFamily:
    "-apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif",
});
